export const GET_Business_Details = "GET_Business_Details"
export const GET_Organization_Details = "GET_Organization_Details"
export const IS_PREVIEW_DISABLED = "IS_PREVIEW_DISABLED"
export const EXCLUDED_OFFER_ITEMS = "EXCLUDED_OFFER_ITEMS"
export const INCLUDED_OFFER_ITEMS = "INCLUDED_OFFER_ITEMS"
export const IS_Organization_PRofile = "IS_Organization_PRofile"
export const IS_Organization_PRofile_Home_Click =
  "IS_Organization_PRofile_Home_Click"
export const IS_Organization_Load = "IS_Organization_Load"
